import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import './Hero.css';
import kg from "../../Assets/break-2-hero.webp";
import kg1 from "../../Assets/empowerrr.webp";
import kg2 from "../../Assets/buildd-2-hero.webp";
// Add more image imports if needed

// Intrinsic sizes of the optimized WebP assets above. Passed as width/height
// so the browser can reserve the correct box before the image loads (the CSS
// still controls the on-screen size via `width` + `height: auto`).
const HERO_IMG_DIMS = [
  { width: 450, height: 450 }, // break-2-hero.webp
  { width: 450, height: 437 }, // buildd-2-hero.webp
  { width: 460, height: 629 }, // empowerrr.webp
];

const Hero = () => {
  const imageStripRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = imageStripRef.current;
    if (el) {
      el.style.opacity = '0';
    }

    const timer = setTimeout(() => {
      setIsVisible(true);
      if (el) {
        el.style.opacity = '1';
      }
    }, 300);

    const handleScroll = () => {
      if (el) {
        // Optionally animate on scroll
        // el.style.transform = `translate(-50%, -50%) rotate(${1 + window.scrollY * 0.01}deg)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const imageList = [
  {
    src: kg,
    alt: "Boldly English learning platform"
  },
  {
    src: kg2,
    alt: "English learning and communication practice"
  },
  {
    src: kg1,
    alt: "Interactive English learning experience"
  }
];// You can add more images here like kg2, kg3

  return (
    <div className="home-hero-container">
      {/* Let the browser discover the first hero image before the JS chunk
          that renders this component finishes parsing (LCP request discovery). */}
      <Helmet>
        <link rel="preload" as="image" href={kg} fetchpriority="high" />
      </Helmet>
      <div className={`home-hero-content ${isVisible ? 'visible' : ''}`}>
        
        <h1 className="home-hero-title">
          <span className="accent">
            Speak English with clarity and confidence.
          </span>
        </h1>

        <p className="home-hero-subtitle">
          <br /> Learn  <span className="home-highlight">anytime,from anywhere</span> - the Boldly way.
        </p>
      </div>

      <div className="home-image-strip" ref={imageStripRef}>
       {imageList.map((image, index) => (
  <div key={index} className="home-image-container">
    <img
      className="home-imges"
      src={image.src}
      alt={image.alt}
      width={HERO_IMG_DIMS[index].width}
      height={HERO_IMG_DIMS[index].height}
      loading="eager"
      decoding="async"
      fetchPriority={index === 0 ? 'high' : 'auto'}
    />
  </div>
))}
      </div>

      <div className="home-background-shapes">
        <div className="home-shape home-shape-1"></div>
        <div className="home-shape home-shape-2"></div>
        <div className="home-shape home-shape-3"></div>
      </div>
    </div>
  );
};

export default Hero;
